import { useTranslation } from '@doccareplus/shared/lib';
import { Button, Drawer } from '@doccareplus/ui';
import { toastApiError } from '@doccareplus/kernel/application';
import { useMarkAllNotificationsReadCommand } from '../application/notifications.command';
import { NotificationList } from './NotificationList';

export function NotificationsDrawer({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation('notifications');
  const markAllRead = useMarkAllNotificationsReadCommand();
  return (
    <Drawer
      title={t('title')}
      closeLabel={t('close')}
      onClose={onClose}
      footer={
        <Button
          variant="ghost"
          fullWidth
          onClick={() => markAllRead.mutate(undefined, { onError: (error) => toastApiError(error, t('markAllReadFailed')) })}
          isLoading={markAllRead.isPending}
        >
          {t('markAllRead')}
        </Button>
      }
    >
      <NotificationList onNotificationSelected={onClose} />
    </Drawer>
  );
}
